import React, { useState, useEffect } from 'react';
import { locationService } from '../services/locationService';
import { countryService } from '../services/countryService';
import './CountrySelectionModal.css';

const CountrySelectionModal = ({ onCountrySelected }) => {
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadCountries();
  }, []);

  const loadCountries = async () => {
    try {
      setLoading(true);
      const countriesData = await locationService.getCountries();
      setCountries(countriesData);
    } catch (error) {
      console.error('Error loading countries:', error);
      setError('Failed to load countries. Please refresh the page.');
    } finally {
      setLoading(false);
    }
  };

  const handleCountrySelect = async () => {
    if (!selectedCountry) {
      setError('Please select a country');
      return;
    }

    try {
      setError('');
      await countryService.setSelectedCountry(selectedCountry);
      onCountrySelected(selectedCountry);
    } catch (error) {
      console.error('Error saving country selection:', error);
      setError('Failed to save country selection. Please try again.');
    }
  };

  return (
    <div className="country-modal-overlay">
      <div className="country-modal">
        <div className="country-modal-header">
          <h2>Select Your Country</h2>
          <p>Choose your country to see products available in your region</p>
        </div>

        {error && (
          <div className="country-modal-error">
            <span className="error-icon">❌</span>
            {error}
          </div>
        )}

        <div className="country-modal-content">
          {loading ? (
            <div className="country-modal-loading">
              <div className="loading-spinner"></div>
              <p>Loading countries...</p>
            </div>
          ) : (
            <div className="country-select-wrapper">
              <label htmlFor="country-select">Country</label>
              <select
                id="country-select"
                value={selectedCountry}
                onChange={(e) => {
                  setSelectedCountry(e.target.value);
                  setError('');
                }}
                className="country-select"
              >
                <option value="">-- Select a country --</option>
                {countries.map((country) => (
                  <option key={country.code} value={country.name}>
                    {country.name} ({country.currency_symbol} {country.currency})
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>

        <div className="country-modal-footer">
          <button
            onClick={handleCountrySelect}
            disabled={!selectedCountry || loading}
            className="country-modal-button"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default CountrySelectionModal;

